export class EmailModel {
    nombre: string;
    email: string;
    telefono:string;
    tipoEvento:string;
    cantInvitados:string;
    fecha:string;
    mensaje:string;
}